<template>
  <div>
    <van-nav-bar left-arrow title="首页" @click-left="back" />
    <div class="content">
      <section v-for="(item, index) in typeList" :key="index">
        <div
          class="item-container"
          :class="{'cardfrist':item.itemType==5,'cardtwo':item.itemType==7}"
          @click="next(item)"
        >
          <img class="type_img" :src="imgSrc(item)" alt />
          <br />
          <div
            class="type_txt"
            :class="{'yellow':item.itemType==5,'green':item.itemType==7}"
          >{{ item.itemTypeTxt }}</div>
        </div>
      </section>
    </div>
  </div>
</template>
<script>
import { httpService } from "@/service/httpService.js";
export default {
  data() {
    return {
      typeList: [
        { itemType: 5, itemTypeTxt: "外出用餐", isNeedHospital: true },
        { itemType: 7, itemTypeTxt: "外出用餐" }
      ]
    };
  },
  methods: {
    back() {
      this.$router.push("/city");
    },
    getList() {
      let params = {
        channel: "app",
        cityId: 127
      };
      httpService.getTenantConfig(params).then(res => {
        if (res && res.success) {
          this.typeList = res.content.data;
        }
      });
    },
    imgSrc(item) {
      let imgSrc = ''
      switch (item.itemType) {
        case 5:
          imgSrc = require("@/assets/img/icon_2.png");
          break;
        case 7:
          imgSrc = require("@/assets/img/icon_3.png");
          break;
        default: 
          imgSrc = require("@/assets/img/icon_3.png");
          break;
      }
      return imgSrc
    },
    next(item) {
      if (item.isNeedHospital) {
        this.$router.push({
          path: "/hospitals"
        });
      } else {
        let routerPath = "";
        switch (item.itemType) {
          case 5:
            routerPath = "/myShops";
            break;
          case 7:
            routerPath = "/myTakeaway";
            break;
        }
        this.$router.push({
          path: routerPath
        });
      }
    }
  },
  mounted() {
    this.getList();
  }
};
</script>
<style lang="scss" scoped>
.item-container {
  width: 100%;
  margin-top: 18px;
  height: 133px;
  text-align: center;
}
.cardfrist {
  border-radius: 18px 18px 0 0;
  background-image: url("../../assets/img/pic_01.png");
  background-size: 100% 100%;
}

.cardtwo {
  border-radius: 18px 18px 0 0;
  background-image: url("../../assets/img/pic_02.png");
  background-size: 100% 100%;
}
.type_img {
  margin-top: 15px;
  width: 14%;
  height: auto;
  display: inline-block;
}

.type_txt {
  margin-top: 10px;
  height: 34px;
  width: 30%;
  border-radius: 18px;
  line-height: 34px;
  background: #fff;
  display: inline-block;
}
</style>
